var global = window
let tooltipHide = null;

global.initTooltips = function(targetSelector) {
    $(targetSelector).find('[title]:not(.protip)').each(function() {
        if ($(this).attr('title')) {
            let protipItems = $(this).attr('data-tip-title', $(this).attr('title')).not('.protip').not('iframe');

            protipItems.mouseenter(function(event) {
                event.stopPropagation();
                if (tooltipHide) {
                    clearTimeout(tooltipHide);
                    tooltipHide = null;
                }
                let container = $('body > .protip-containers');
                if (!container.length) {
                    container = $('<div class="protip-containers"></div>')
                    $('body').append(container);
                    container.append('<div class="protip-container" style="max-width: 600px; min-width: 184px; transform: translateX(-50%) translateY(-100%);" data-pt-position="top"><span class="protip-arrow"></span><i class="fa"></i><div class="protip-content"></div></div>');
                }
                const el = $(this);
                const icon = el.data('tip-icon');
                const title = el.data('tip-title');
                const scheme = (el.data('tip-scheme'))?el.data('tip-scheme'):'default';
                const pos = el.offset();
                const x = pos.left + (el.outerWidth() / 2);
                const y = pos.top - 20;
                const tooltip = $('.protip-containers .protip-container');
                const tooltipIcon = tooltip.find('.fa');
                tooltip.attr('class', 'visible protip-container protip-skin-default protip-skin-default--size-normal protip-skin-default--scheme-'+scheme+' protip-show').css('left', x+'px').css('top', y+'px');
                tooltip.find('.protip-content').html(title);
                tooltip.data('str', el.get(0).toString())
                $('.tooltiped').removeClass('tooltiped');
                el.addClass('tooltiped');
                if (icon) tooltipIcon.show().attr('class', 'fa '+icon);
                else tooltipIcon.hide();
                // container.append('<div class="protip-container protip-skin-default protip-skin-default--size-normal protip-skin-default--scheme-'+scheme+' protip-show" style="max-width: 300px; min-width: 224px; left: '+x+'px; top: '+y+'px; transform: translateX(-50%) translateY(-100%);" data-pt-position="top"><span class="protip-arrow"></span>'+((icon)?'<i class="fa '+icon+'"></i>':'')+'<div class="protip-content">'+title+'</div></div>');
            });

            protipItems.mouseleave(function(event) {
                event.stopPropagation();
                const el = $(this);

                if (tooltipHide) {
                    clearTimeout(tooltipHide);
                    tooltipHide = null;
                }

                tooltipHide = setTimeout(function() {
                    const tooltip = $('.protip-containers .protip-container');
                    $('.tooltiped').removeClass('tooltiped');
                    // if (el.get(0).toString() == tooltip.data('id') || strip_tags(tooltip.find('.protip-content').text()) == strip_tags(el.data('tip-title')))
                    $('.protip-container').removeClass('visible');

                    tooltipHide = setTimeout(function() {
                        const tooltip = $('.protip-containers .protip-container');
                        $('.protip-container').addClass('hidden');
                    }, 250)
                }, 10)
            });

            protipItems.addClass('protip');
            $(this).removeAttr('title')
        }
    });

    /*
    $.protip({
        "selector":           '.protip',
        "namespace":          'tip',
        "observer":           false,
        "delayResize":        100,
        "iconTemplate":     '<i class="fa {icon}"></i>',
        "defaults":           {
            "position": 'top',
            "offset-top": 20,
            "scheme": 'default'
        }
    });
    */
}

global.removeTooltips = function(targetSelector) {
    $(targetSelector).find('.protip').each(function() {
        $('[data-pt-identifier='+$(this).data('tipIdentifier')+']').remove();
    })
}
